function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M13.5 2a1 1 0 00-1 1v16.085l2-1.586V4h4v10.326l2-1.586V3a1 1 0 00-1-1h-6zM10.5 19v1.671l-2 1.586V20h-4v5.43l-2 1.586V19a1 1 0 011-1h6a1 1 0 011 1zM10.5 27.053L6.784 30H9.5a1 1 0 001-1v-1.947zM14.5 28v-4.12l-2 1.587V29a1 1 0 001 1h6a1 1 0 001-1v-9.878l-2 1.586V28h-4zM22.5 29V17.536l2-1.587V28h4V13h-.281l2.057-1.631c.14.172.224.392.224.631v17a1 1 0 01-1 1h-6a1 1 0 01-1-1zM31.121 8.783a1 1 0 00-1.242-1.567l-29 23a1 1 0 001.242 1.567l29-23z",
  fill: "currentColor"
})));